import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { KANBANBOARDS_DOMAIN } from './constants';

const selectKanbanBoardsDomain = state => state[KANBANBOARDS_DOMAIN] || initialState;

export const selectKanbanBoards = () => createSelector(selectKanbanBoardsDomain, d => d.boards);

export const selectKanbanBoard = id => createSelector(selectKanbanBoardsDomain, d => d.boards.find(b => b.id == id));

export const selectKanbanBoardColumnCells = (bid, cid) => createSelector(selectKanbanBoardsDomain, d => d.columnCells[cid]);

export const selectKanbanBoardColumnDirty = (bid, cid) => createSelector(selectKanbanBoardsDomain, d => d.columnDirty[cid]);

export const selectActiveKanbanBoardId = () => createSelector(selectKanbanBoardsDomain, d => d.activeBoardId);

export const selectActiveKanbanBoard = () =>
  createSelector(selectKanbanBoards, selectActiveKanbanBoardId, (boards, bid) => boards?.find(b => b.id === bid));
export const selectActiveKanbanColumns = () =>
  createSelector(selectActiveKanbanBoard, board => board?.columns?.map(col => col.id));

export const selectKanbanBoardProgressBarValue = (boardId, targetType, targetId) =>
  createSelector(selectKanbanBoardsDomain, d => d.progressBarValues[`${boardId}-${targetType}-${targetId}`]);

export const selectKanbanBoardRequestQueue = () => createSelector(selectKanbanBoardsDomain, d => d.requestQueue);

export const selectKanbanBoardRequestQueueActive = () => createSelector(selectKanbanBoardsDomain, d => d.requestQueueActive);

export const selectanKanbanCacheStatus = () => createSelector(selectKanbanBoardsDomain, d => d.cacheStatus);

export const selectKanbanCompanyToggle = () => createSelector(selectKanbanBoardsDomain, d => d.toggleKanbanCompanyModal);

export const selectKanbanFilter = () => createSelector(selectKanbanBoardsDomain, d => d.filter);

export const selectKanbanColumnSort = colId => createSelector(selectKanbanBoardsDomain, d => d.columnSort[colId]);
